export * from './medispan-log-result.component';
